import {
  ContentBlocks_Position,
  ContentBlocks_TextModule,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/content_blocks.types';
import {
  ContentBlockText,
  RowSection,
  tabletAndUp,
} from '@aboutyou/ui-components';
import {styled as linariaStyled} from '@linaria/react';
import React from 'react';
import sc, {css} from 'styled-components';
import {alignmentMap, fontMap, horizontalPositionMap} from '../transforms';

export const Text: React.FC<{
  className?: string;
  content: ContentBlocks_TextModule;
  blockId?: number;
  testId?: string;
}> = ({className, content, blockId, testId = 'customPageText'}) => {
  if (content.text.text === '') return null;

  return (
    <StyledRowSection
      className={className}
      $backgroundColor={content.backgroundColor}
      centerContent
      position={content.position}
      data-content-block={blockId}
    >
      <ContentWrapper>
        <ContentBlockText
          alignment={alignmentMap[content.text.alignment]}
          color={content.text.color}
          size={fontMap[content.text.size]}
          text={content.text.text}
          testId={testId}
          isAParagraph
        />
      </ContentWrapper>
    </StyledRowSection>
  );
};

const StyledRowSection = linariaStyled(RowSection)<{
  $backgroundColor?: string;
  position: ContentBlocks_Position;
}>`
  background-color: ${({$backgroundColor}) => $backgroundColor ?? ''};
  display: flex;
  justify-content: ${({position}) =>
    position ? horizontalPositionMap[position] : 'center'};
`;

export const ContentWrapper = sc.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1rem 3rem 1rem;

  ${tabletAndUp(css`
    max-width: 50%;
  `)}
`;
